export default [
  {
    name: "TEMCAS",
    id: "8c4f8258-4080-4eff-aa21-5e24b449f2e6",
  },
  {
    name: "TEM21",
    id: "d5d97dc4-67e6-4888-9d36-8c8eb57425df",
  },
];
